export const logoEnum = {
    1: { logname: 'store_space_logo' },
    2: { logname: 'operator2' }
};